import React, { Component, Fragment } from "react";
import LoginContainer from "../containers/LoginContainer";
import FormView from "../components/FormView";
import Title from "../components/SidePanel/Title";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Header from "../components/Header";

class LoginRoute extends Component {

    render() {
        const { loggedIn } = this.props;
        if ( loggedIn )
            return <Redirect to="/user"/>
        return (
            <Fragment>
                <Header/>
                <FormView
                    content={
                        <LoginContainer/>
                    }
                    sideContent={
                        <Title/>
                    }
                />
            </Fragment>
        );
    }

}

export default connect(
    state => ({
        loggedIn: state.user.bearerToken ? true : false
    })
)( LoginRoute );